import { getMetaSubtreeEntityIds } from '~/utils/viewer/metadata-graph';

export function hideOthersAction() {
  const { t } = useI18n();

  return {
    title: t('components.xeokit_viewer.context_menu.hide_others'),
    doAction: function (context) {
      const viewer = context.viewer;
      const scene = viewer.scene;
      const entity = context.entity;
      const metaId = String(entity.originalSystemId ?? entity.id);
      const subtreeIds = getMetaSubtreeEntityIds(viewer, metaId);
      if (!subtreeIds.length) {
        return;
      }
      scene.setObjectsVisible(scene.visibleObjectIds, false);
      scene.setObjectsXRayed(scene.xrayedObjectIds, false);
      scene.setObjectsSelected(scene.selectedObjectIds, false);
      scene.setObjectsHighlighted(scene.highlightedObjectIds, false);
      for (const objectId of subtreeIds) {
        const subtreeEntity = scene.objects[objectId];
        if (subtreeEntity) {
          subtreeEntity.visible = true;
        }
      }
    },
  };
}
